module.exports = __webpack_public_path__ + "static/iron-ore-ceb1692ee9a7e399256327852992652a.png";